import React from 'react'
import { MaskedInputField } from '@adc/ui-core'
const zipMask = Array(5).fill(/\d/)

const ZipCode = props => {
  return <MaskedInputField mask={zipMask} label='Zip Code' {...props} />
}

export default ZipCode
